// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation-module_navigation_sR10y","board-item-padding-bottom":"Navigation-module_board-item-padding-bottom_eFMgq"};